import { NgxPermissionsModule } from 'ngx-permissions';
import { RouterModule } from '@angular/router';
import { PropertyTabsComponent } from './property-tabs.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module';

@NgModule({
  declarations: [
    PropertyTabsComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    NgSelectModule,
    RouterModule,
    NgxPermissionsModule,
    TranslateModule,
    ContentEditableModule
  ],
  exports: [
    PropertyTabsComponent
  ]
})

export class PropertyTabsModule { }
